/**
 * Saves a fetched file under the name its `content-disposition` gives, or
 * `fallbackName` when it gives none.
 */
export async function saveResponseAsFile(
    response: Response,
    fallbackName: string
): Promise<void> {
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const match = response.headers
        .get('content-disposition')
        ?.match(/filename="([^"]+)"|filename=([^;]+)/);

    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.download = match ? match[1] ?? match[2] : fallbackName;
    document.body.appendChild(link);
    link.click();

    // Some browsers have not started reading the blob when `click()` returns,
    // and revoking early leaves them with an empty file.
    setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
    }, 100);
}
